export type SidebarSection = {
  children: SidebarItemsType[];
};

type SidebarLinkBase = {
  title: string;
  icon?: React.ComponentType;
  children?: SidebarItemsType[];
  badge?: string;
  target?: string;
  eventCode?: string;
};

export type SidebarLink = SidebarLinkBase & ({ href: string } | { onAction: () => void });

export type SidebarItemsType = SidebarSection | SidebarLink;

export function isSidebarLink(item: SidebarItemsType): item is SidebarLink {
  return 'title' in item;
}
